// modules
import * as Sentry from '@sentry/react'
import { ThemeProvider } from '$setup/material-theme'
import AppCrashed from '$comp/error-pages/app-crashed/app-crashed'
import { calErrorPageUrl, getErrorPageUrl } from '$setup/error-assistant'

const Fallback = () => (
  <ThemeProvider>
    <AppCrashed />
  </ThemeProvider>
)

const renderFallback = () => <Fallback />

export const ErrorBoundary = ({
  children = null,
}: {
  children: JSX.Element | JSX.Element[]
}) => (
  <Sentry.ErrorBoundary
    beforeCapture={scope => {
      const errorPageUrl = getErrorPageUrl()
      if (!errorPageUrl) return
      const errorPageUrlString = calErrorPageUrl(errorPageUrl)
      if (!errorPageUrlString) return
      scope.setTag('errorPageUrl', errorPageUrlString)
    }}
    fallback={renderFallback}
  >
    {children}
  </Sentry.ErrorBoundary>
)
